import { BaseModel } from "./base";
import SituacaoVeiculo from "./situacaoVeiculo";

export class Transportadora extends BaseModel {
  constructor(
    public id: number,
    public numOrdem: number,
    public cnpj: string,
    public token: string,
    public nomefantasia: string,
    public razaosocial: string,
    public situacaoVeiculo?: SituacaoVeiculo,
    public updatedAt?: Date,
    public createdAt?: Date,
    public deletedAt?: Date
  ) {
    super(id);
  }
}
